import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { RmpvDetalheProdutivoServiceService } from '../rmpv-detalhe-produtivo-service/rmpv-detalhe-produtivo-service.service';
import { Filtros } from '../../../../shared/crud/Filtro/Filtros';
import { ListaBase } from '../../../../shared/crud/ListaBase';
import { ExportExcelService } from '../../../../shared/excel-service/export-excel.service';

@Component({
  selector: 'app-rmpv-detalhe-produtivo-lista',
  templateUrl: './rmpv-detalhe-produtivo-lista.component.html',
  styleUrls: ['./rmpv-detalhe-produtivo-lista.component.css']
})

export class RmpvDetalheProdutivoListaComponent extends ListaBase implements OnInit {
  data: any;
  carregando = false
  columns: any[];
  id: string

  produtividade = 0;
  produtividadeHT: number;
  produtividadeHTStrg: string;

  eficiencia: string;
  eficienciaHV: string;
  eficienciaHVStrg: string;

  utilizacao = 0;
  utilizacaoHVStrg: string;
  utilizacaoHV: number;

  visualizarTotalRegistros: boolean;
  exibirBotaoDetalhes: boolean;

  configShowNumber = {
    animation: 'count',
    format: '(.ddd),dd'
  };

  dadosTranslate = {
    "produtivo": "rmpv.produtividade.grid.produtivo",
    "horasTrabalhadas": "rmpv.produtividade.grid.horasTrabalhadasGrid",
    "horasDisponiveis": "rmpv.produtividade.grid.horasDisponiveisGrid",
    "horasVendidas": "rmpv.produtividade.grid.horasVendidasGrid",
    "percentualMaoDeObra": "rmpv.produtividade.grid.porcentagemProdutividadeGrid",
    "statusMaoDeObra": "rmpv.produtividade.grid.statusProdutividadeGrid",
    "percentualProdutividade": "rmpv.produtividade.grid.porcentagemEficienciaGrid",
    "statusProdutividade": "rmpv.produtividade.grid.statusEficienciaGrid",
    "percentualEficiencia": "rmpv.produtividade.grid.porcentagemUtilizacaoGrid",
    "statusEficiencia": "rmpv.produtividade.grid.statusUtilizacaoGrid",
  }

  getTranslate(value) {
    return this.dadosTranslate[value];
  }


  constructor(service: RmpvDetalheProdutivoServiceService, toastr: ToastrService, router: Router, private exportExcelService: ExportExcelService) {
    super(service, toastr, router);
    this.visualizarTotalRegistros = false;
    this.listagemComPaginacao = true;
    this.quantidadeRegistrosPorPagina = 60;
    this.exibirBotaoDetalhes = false;
    this.exibirBotaoNovo = false;
    this.nomeModulo = 'produtividade-detalhado';
  }

  ngOnInit() {
    this.getAll();
    this.columns = [
      { field: 'nomeProdutivo', header: 'rmpv.produtividade.grid.produtivo', width: '13rem' },
      { field: 'horasTrabalhadas', header: 'rmpv.produtividade.grid.horasTrabalhadasGrid', width: '4rem' },
      { field: 'horasDisponiveis', header: 'rmpv.produtividade.grid.horasDisponiveisGrid', width: '4rem' },
      { field: 'horasVendidas', header: 'rmpv.produtividade.grid.horasVendidasGrid', width: '4rem' },
      { field: 'percentualMaoDeObra', header: 'rmpv.produtividade.grid.porcentagemProdutividadeGrid', width: '10rem' },
      { field: 'statusMaoDeObra', header: 'rmpv.produtividade.grid.statusProdutividadeGrid', width: '12rem' },
      { field: 'percentualProdutividade', header: 'rmpv.produtividade.grid.porcentagemEficienciaGrid', width: '9rem' },
      { field: 'statusProdutividade', header: 'rmpv.produtividade.grid.statusEficienciaGrid', width: '11rem' },
      { field: 'percentualEficiencia', header: 'rmpv.produtividade.grid.porcentagemUtilizacaoGrid', width: '7rem' },
      { field: 'statusEficiencia', header: 'rmpv.produtividade.grid.statusUtilizacaoGrid', width: '10rem' },
    ];
  }

  protected getListagemComFiltros(): boolean {
    return this.filtros.dealer
      || this.filtros.produtivos
      || this.filtros.data_inicial
      || this.filtros.data_final;
  }

  getAll() {
    let objFiltro: Filtros = new Filtros();
    for (const chave in this.filtros) {
      if (this.filtros.hasOwnProperty(chave) && this.filtros[chave]) {
        super.incluirItemFiltro(chave, objFiltro);
      }
    }
    this.carregando = true
    this.service.buscar(objFiltro).then(res => {
      this.data = res.dados[0].produtivos

      this.produtividade = res.produtividade.ideal;
      this.produtividadeHT = res.produtividade.percentualProdutividade;
      // this.produtividadeHTStrg = `${res.produtividade.horasTrabalhadas}%`;

      this.eficiencia = res.eficiencia.ideal;
      this.eficienciaHV = res.eficiencia.percentualEficiencia;
      // this.eficienciaHVStrg = `${res.eficiencia.horasVendidas}%`;

      this.utilizacao = res.utilizacao.ideal;
      this.utilizacaoHV = res.utilizacao.percentualUtilizacao;
      // this.utilizacaoHVStrg = `${res.utilizacao.horasVendidas}%`;

      this.carregando = false
    });
  }

  //export Excel
  exportExcel() {
    this.exportExcelService.nomeModulo = this.nomeModulo;
    this.exportExcelService.ExportTOExcel();
  }

  voltar() {
    let url = '';
    for (const filtro in this.filtros) {
      if (this.filtros.hasOwnProperty(filtro)) {
        url += url ? '&' + filtro + '=' + this.filtros[filtro] : '?' + filtro + '=' + this.filtros[filtro];
      }
    }
    this.router.navigate(['produtividade'])
    return 'produtividade' + url
  }

}
